import { render, staticRenderFns } from "./radio-buttons.vue?vue&type=template&id=504cf432&lang=pug&"
import script from "./radio-buttons.vue?vue&type=script&lang=js&"
export * from "./radio-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports